import { ChevronIcon } from 'mode-shared/icons';

export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
}: {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}) => {
  if (totalPages <= 1) return null;

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="flex items-center justify-center gap-4 mt-4">
      <button
        onClick={handlePrevious}
        disabled={currentPage === 1}
        className="flex items-center justify-center w-8 h-8 rounded border border-neutral-900 bg-neutral-950 text-grey-100 hover:bg-neutral-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        aria-label="Previous page"
      >
        <ChevronIcon className="w-4 h-4 rotate-90" />
      </button>

      <div className="text-sm text-neutral-300">
        Page {currentPage} of {totalPages}
      </div>

      <button
        onClick={handleNext}
        disabled={currentPage === totalPages}
        className="flex items-center justify-center w-8 h-8 rounded border border-neutral-900 bg-neutral-950 text-grey-100 hover:bg-neutral-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        aria-label="Next page"
      >
        <ChevronIcon className="w-4 h-4 -rotate-90" />
      </button>
    </div>
  );
};
